var _circle, _circle2, _g, _path, _path2, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOttoLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FDF2F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2861_57",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FFFBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2861_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8305 37.2565C69.7383 42.2091 73.4569 41.7817 79.0621 49.7047C84.9937 58.089 87.5833 56.757 90.2925 59.2868C93.0018 61.8166 95.4047 46.4243 84.5357 37.606C77.5584 31.945 67.9227 32.3039 68.8305 37.2565Z",
    fill: "#AEA075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3234 30.7142C72.1231 35.9916 79.0296 38.3147 84.6348 46.2377C90.5663 54.622 87.4936 61.8431 90.2029 64.3729C92.9121 66.9027 98.8623 43.5639 89.2135 33.4251C78.0281 21.6718 74.5236 25.4368 73.3234 30.7142Z",
    fill: "#D1C394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7003 38.2565C42.7924 43.2091 39.0738 42.7817 33.4686 50.7047C27.5371 59.089 24.9474 57.757 22.2382 60.2868C19.529 62.8166 17.1261 47.4243 27.995 38.606C34.9724 32.945 44.6081 33.3039 43.7003 38.2565Z",
    fill: "#AEA075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2074 31.7142C40.4076 36.9916 33.5012 39.3147 27.896 47.2377C21.9644 55.622 25.0371 62.8431 22.3279 65.3729C19.6186 67.9027 13.6684 44.5639 23.3173 34.4251C34.5027 22.6718 38.0071 26.4368 39.2074 31.7142Z",
    fill: "#D1C294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 115C90 115 77 127 55.5 127C35.5 127 23.5 116.5 23.5 116.5C23.5 99.3792 33 49.5 55.5 49.5C75.5 49.5 90 97.8792 90 115Z",
    fill: "url(#paint0_linear_2861_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3482 28.0047C15.0688 28.5707 38.2225 79.2538 40.6943 83.7109C43.1662 88.1681 70.166 88.1679 72.6636 83.2651C75.1612 78.3623 97.6276 27.4387 56.3482 28.0047Z",
    fill: "url(#paint1_linear_2861_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3846 76.3819C56.3846 76.3819 63.5516 71.529 63.5991 80.1322C63.6334 86.3309 60.3992 90.6876 56.3757 90.7098C52.3521 90.7321 49.0627 86.4114 49.0284 80.2127C48.9833 72.035 56.3846 76.3819 56.3846 76.3819Z",
    fill: "#C18282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.422 76.5C56.422 76.5 43.1924 86.5407 43.1059 75.1525C43.0436 66.9471 49.0055 61.1583 56.422 61.102C63.8384 61.0457 69.901 66.7432 69.9633 74.9486C70.0455 85.7736 56.422 76.5 56.422 76.5Z",
    fill: "#AFA16E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9773 66.7024C61.9988 68.8345 59.4988 71.9695 56.475 72C53.4512 72.0305 51.0488 68.945 51.0273 66.8129C51.0058 64.6807 53.4512 64.0857 56.475 64.0552C59.4988 64.0247 61.9558 64.5703 61.9773 66.7024Z",
    fill: "#3D3D3D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4443 55.4492C49.577 57.3816 47.5916 55.5764 45.3062 55.7333C43.0208 55.8902 41.3008 57.9498 41.1681 56.0174C41.0355 54.085 42.8527 53.4409 45.1381 53.284C47.4235 53.1272 49.3117 53.5168 49.4443 55.4492Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0591 55.4492C63.9264 57.3816 65.9118 55.5764 68.1972 55.7333C70.4826 55.8902 72.2026 57.9498 72.3353 56.0174C72.4679 54.085 70.6507 53.4409 68.3653 53.284C66.0799 53.1272 64.1917 53.5168 64.0591 55.4492Z",
    fill: "#3D3D3D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2861_57)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3674 49.4527C68.6718 47.6664 67.6153 46.6928 66.5142 46.2793C65.4096 45.8645 64.2622 46.0143 63.393 46.4698C60.4809 47.9958 59.9871 51.111 60.7858 54.1665C61.5845 57.2219 63.6826 60.2253 65.9531 61.5333C68.5692 61.5939 71.9311 60.1357 74.2116 57.9554C76.4922 55.775 77.7031 52.8694 76.0191 50.0403C75.5172 49.1971 74.6181 48.4686 73.4599 48.2435C72.3053 48.0191 70.8955 48.2953 69.3674 49.4527Z",
    fill: "#FC5353"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2861_57)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5742 49.3439C42.0635 48.1639 40.6579 47.8668 39.5001 48.0741C38.3386 48.282 37.4289 48.9971 36.9145 49.8328C35.1911 52.6326 36.3584 55.5627 38.6064 57.781C40.8542 59.9993 44.1924 61.5087 46.8125 61.4728C49.0922 60.1881 51.237 57.2168 52.0831 54.1773C52.9292 51.1377 52.4853 48.0213 49.5922 46.45C48.7299 45.9817 47.5848 45.8149 46.4742 46.2132C45.367 46.6103 44.2963 47.5682 43.5742 49.3439Z",
    fill: "#FC5353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2861_57",
    x: 59.3436,
    y: 44.936,
    width: 18.5628,
    height: 17.699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2861_57"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2861_57",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2861_57",
    x: 34.9876,
    y: 44.8894,
    width: 18.5779,
    height: 17.6841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2861_57"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2861_57",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2861_57",
    x1: 56.75,
    y1: 50,
    x2: 56.75,
    y2: 127.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0D2A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2861_57",
    x1: 56.5,
    y1: 28,
    x2: 56.5,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC9F6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOttoLove);
export default __webpack_public_path__ + "static/media/otto-love.ccbbedfbac26ad3fa0d68d9d0d95de7f.svg";
export { ForwardRef as ReactComponent };